import * as types from './types';

const initialState = {
  state: {
    default: { active: true, status: 'nondiscarded', iconName: 'email', trackLabel: 'Bandeja de entrada' },
    favorite: { active: false, status: 'favorite,nondiscarded', iconName: 'favorite', trackLabel: 'Destacados' },
    deleted: { active: false, status: 'discarded', iconName: 'remove', trackLabel: 'Eliminados' },
    spam: { active: false, status: 'nondiscarded,spam', iconName: 'alert', trackLabel: 'Spam' }
  },
  status: 'nondiscarded',
  unRead: '',
  loading: undefined
};

function inboxReducer(state = initialState, action = {}) {
  switch (action.type) {
    case types.FETCH_UNREAD:
      state.loading = 'loading';
      return { ...state };
    case types.FETCH_UNREAD_SUCCEEDED:
      state.unRead = action.payload;
      return { ...state };
    default:
      return { ...state };
  }
}

export default inboxReducer;
